import clsx from "clsx";
import Avatar from "react-avatar";
import dateformat from "dateformat";
import shortenText from "../utils/shortenText";
const NewsCard = ({ showBody=false, variant, shadowless, thumbNailClass, blog = {} }) => {

  const titleLength = blog?.thumbnail ? 72 : 100;
  return (
    <div
      className={clsx({
        " bg-white w-full h-full": true,
        "flex items-center": variant === "landscape",
        "shadow-sub3": !shadowless,
      })}
    >
      {!!blog?.content?.banner_image?.filename && (
        <div
          className={clsx({
            " bg-caramBar self-stretch": true,
            " flex-shrink-0 h-full overflow-hidden flex-grow":
              variant === "landscape",
            "h-172 md:h-250": variant !== "landscape",
            [thumbNailClass]: true,
          })}
        >
          <img
            alt="news"
            src={blog?.content?.banner_image?.filename}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="bg-white px-6 py-4 md:py-6">
        <div className="flex  text-10px leading-4 text-chestNut">
          <span className="flex items-center px-2 py-1 bg-seasideVilla rounded">
            {!!blog?.content?.type && blog?.content?.type}
          </span>
        </div>
        <span className="inline-block my-1 text-xs leading-6 text-seal lg:text-sm lg:mt-4 lg:mb-2">
        {`${dateformat(blog?.first_published_at, "dd mmmm, yyyy")}`}        </span>
        <h6 className="font-semibold  leading-6 md:leading-7 text-base capitalize md:text-lg  text-blackEmerald ">
          {!!blog?.content?.title && shortenText(blog?.content?.title, titleLength)}
        </h6>
        <div className={
          clsx({
            " my-2 text-sm leading-6 font-normal text-metal font-poppins lg:text-base lg:my-4": true,
            "block": showBody,
            "hidden": !showBody
          })
        }>
          {!!blog?.content?.short_brief && blog?.content?.short_brief}
        </div>
        {false && (
          <button className="text-xs text-tamarindo leading-snug">
            Read more
          </button>
        )}
        <div className="author mt-2">
          <div className="flex items-center">
            {blog?.content?.author?.[0]?.picture?.filename && (
              <Avatar
                className="ml-3 "
                round
                size="32"
                src={blog?.content?.author?.[0]?.picture?.filename}
                name={blog?.content?.author?.[0]?.name}
              />
            )}
            <p className="text-sm text-seal leading-5 capitalize">
              {blog?.content?.author?.[0]?.name &&
                `By ${
                  blog?.content?.author?.[0]?.name
                }`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
